import React from 'react';

// Dashed ring sits inside the clock face at a smaller radius
const R = 16;
const C = +(2 * Math.PI * R).toFixed(2); // ≈ 100.53

export const WaitForConfirmationIllustration = () => (
  <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      {/*
        Two-layer sweep mask:
        - White arc: grows 0 → C over 1s (ease-in — starts slow, builds speed)
        - Black arc: holds 0 for 1s, then grows 0 → C over 0.5s (aggressive ease-in — accelerates)
        Both arcs start at 12 o'clock (rotate -90°) and sweep clockwise.
        Net visible region = white − black.
      */}
      <mask id="pbb-clock-sweep-mask">
        <rect width="180" height="180" fill="black" />
        {/* Reveal arc */}
        <circle cx="122" cy="52" r={R} fill="none" stroke="white" strokeWidth="6"
          transform="rotate(-90 122 52)">
          <animate
            attributeName="stroke-dasharray"
            values={`0 ${C}; ${C} 0; ${C} 0`}
            keyTimes="0; 0.667; 1"
            calcMode="spline"
            keySplines="0.4 0 0.8 1; 0 0 1 1"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </circle>
        {/* Erase arc — accelerates aggressively */}
        <circle cx="122" cy="52" r={R} fill="none" stroke="black" strokeWidth="6"
          transform="rotate(-90 122 52)">
          <animate
            attributeName="stroke-dasharray"
            values={`0 ${C}; 0 ${C}; ${C} 0`}
            keyTimes="0; 0.667; 1"
            calcMode="spline"
            keySplines="0 0 1 1; 0.7 0 1 1"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </circle>
      </mask>
    </defs>

    <style>{`
      @keyframes sonar-pulse {
        0%   { transform: scale(0.88); opacity: 0.45; }
        100% { transform: scale(1.45); opacity: 0; }
      }
      .sonar-ring {
        transform-origin: 85px 95px;
        animation: sonar-pulse 2.5s ease-out infinite;
      }
      .sonar-ring-delay {
        transform-origin: 85px 95px;
        animation: sonar-pulse 2.5s ease-out 1.25s infinite;
      }
    `}</style>

    {/* Sonar pulse rings */}
    <circle className="sonar-ring" cx="85" cy="95" r="72" fill="#D8DADB" />
    <circle className="sonar-ring-delay" cx="85" cy="95" r="72" fill="#D8DADB" />

    {/* Static gray base */}
    <circle cx="85" cy="95" r="62" fill="#ECEEF0" />

    {/* Phone body */}
    <rect x="44" y="38" width="62" height="104" rx="8" fill="white" stroke="#C4D2D9" strokeWidth="1.5" />

    {/* CONFIRM pill */}
    <rect x="51" y="90" width="50" height="17" rx="8.5" fill="#7A8A90" />
    <text
      x="76" y="103"
      textAnchor="middle"
      fill="white"
      fontSize="6.5"
      fontWeight="700"
      fontFamily="-apple-system, BlinkMacSystemFont, sans-serif"
      letterSpacing="0.6"
    >
      CONFIRM
    </text>

    {/* Clock face */}
    <circle cx="122" cy="52" r="22" fill="white" stroke="#C4D2D9" strokeWidth="1.5" />

    {/* Dashed green ring — inside the clock face at r=16, revealed by sweep mask */}
    <circle
      cx="122" cy="52" r={R}
      fill="none"
      stroke="#00d592"
      strokeWidth="2.5"
      strokeDasharray="5 3.5"
      mask="url(#pbb-clock-sweep-mask)"
    />

    {/* Clock hands */}
    <line x1="122" y1="43" x2="122" y2="53" stroke="#C4D2D9" strokeWidth="2" strokeLinecap="round" />
    <line x1="122" y1="53" x2="129" y2="53" stroke="#C4D2D9" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
